import { Box } from "@mui/system"
import Typography from "antd/lib/typography/Typography"
import FermeNo1 from "./FermeNo1"
import EmptyStockSvg from "assets/img/img2.svg";
const NoStockOrNoCampaign = () => {

    return (
        <Box align="center"
            style={{
                width: '100%',
                padding: '100px 0'
            }}>
            <img src={EmptyStockSvg} alt="Aucun stock img" />
            <Typography align="center">
                <br />
                {
                    (() => {
                            return <>

                                Vous n’avez pas encore de fiche de stock
                                <br />
                                Cliquez sur le bouton ci-dessous pour en créer une
                            </>
                        
                    })()
                }
                <br /><br />
            </Typography>
            <div className="creatbtn-redirect">
                <FermeNo1 />
                {/* <Top */}
            </div>
        </Box>
    )
}

export default NoStockOrNoCampaign;